
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M14.41 4.331l-.002.002-.001.001-1.501 1.511-2.751-2.75 1.51-1.502.002-.001.002-.002a.733.733 0 011.038 0l1.683 1.683c.309.309.31.767.02 1.058zM2.567 14.317l-.884-.884.38-2.3.575-.57h1.3v1.5h1.5v1.3l-.572.574-2.3.38zm1.203-4.88l5.32-5.286 2.76 2.759-5.287 5.32v-1.292h-1.5v-1.5H3.77zm11.593-7.136L13.68.618a2.108 2.108 0 00-2.984 0L.778 10.472.01 15.128a.75.75 0 00.862.862l4.656-.768 9.854-9.919a2.11 2.11 0 00-.02-3.002z"}})])
          )
        }
      }
    